import React, { useContext, useEffect, useState } from 'react';
import '../createSurvey.css';
import Navbar from '../../../components/navbar/Navbar';
import Steps from '../../../components/steps';
import { Button } from '@mui/material';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import { useLocation, useNavigate } from 'react-router-dom';
import Footer from '../../../components/navbar/Footer';
import { faCoins } from '@fortawesome/free-solid-svg-icons';
import { faSmile } from '@fortawesome/free-solid-svg-icons';
import { faRunning } from '@fortawesome/free-solid-svg-icons';
import { faBrain } from '@fortawesome/free-solid-svg-icons';
import { faUsers } from '@fortawesome/free-solid-svg-icons';
import { faHandshakeSimple } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import axios from 'axios';
import Split from './Split';
import { StepsContext } from '../../../context/stepsContext';
import Toast from '../../../components/toast/Toast';
import Pickles from '../../../components/particles/Pickles';
import { REACT_APP_SURVEY_ID, REACT_APP_SURVEY_ID_ER } from '../../../config';

export default function StepThreeThree({ minutesDisplay, secondsDisplay }) {
  const { state: finalStep } = useLocation();
  const { survey_id } = finalStep;
  const survey_id_manage =
    survey_id === REACT_APP_SURVEY_ID
      ? REACT_APP_SURVEY_ID
      : REACT_APP_SURVEY_ID_ER;

  const { state } = finalStep;
  const { feeling } = finalStep;
  const { stepone } = finalStep;
  const { stepThree } = finalStep;
  const { personType } = finalStep;
  const { keyAreaTopTexts } = finalStep;
  const { selectedConstructsTop } = finalStep;
  const { selectedConstructsBottom } = finalStep;
  const { selectedCostitems } = finalStep;
  const { selectedAbilities } = finalStep;
  const { selected } = finalStep;
  console.log('finalStep', finalStep);
  console.log('finalStep', state);
  /* eslint-disable */
  const listIcon = [
    faCoins,
    faHandshakeSimple,
    faRunning,
    faBrain,
    faSmile,
    faUsers,
  ];
  const [selectedArea, setSelectedArea] = useState('');
  const [allAreas, setAllAreas] = useState([
    { name: 'Financial', id: 1, icon: '' },
    { name: 'Professional', id: 2, icon: '' },
    { name: 'Physical', id: 3, icon: '' },
    { name: 'Mental', id: 4, icon: '' },
    { name: 'Social', id: 5, icon: '' },
    { name: 'Societal', id: 6, icon: '' },
  ]);
  const [financial, setFinancial] = useState();
  const [professional, setProfessional] = useState();
  const [physical, setPhysical] = useState();
  const [mental, setMental] = useState();
  const [social, setSocial] = useState();
  const [societal, setSocietal] = useState();
  const [profileData, setProfileData] = useState({});
  const [type, setType] = useState('');

  const [financialSelected, setFinancialSelected] = useState([]);
  const [professionalSelected, setProfessionalSelected] = useState([]);
  const [physicalSelected, setPhysicalSelected] = useState([]);
  const [mentalSelected, setMentalSelected] = useState([]);
  const [socialSelected, setSocialSelected] = useState([]);
  const [societalSelected, setSocietalSelected] = useState([]);

  useEffect(() => {
    const fetchPosts = async () => {
      setFinancial(state?.areaServices?.financial);
      setProfessional(state?.areaServices?.professional);
      setMental(state?.areaServices?.mental);
      setPhysical(state?.areaServices?.physical);
      setSocial(state?.areaServices?.social);
      setSocietal(state?.areaServices?.societal);
    };

    fetchPosts();
  }, [state]);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const [selectedSub, setSelectedSub] = useState([]);

  const handleClick = (selected) => {
    setSelectedArea(selected?.id);
    if (selected?.id === 1) {
      setSelectedSub(financial);
    } else if (selected?.id === 2) {
      setSelectedSub(professional);
    } else if (selected?.id === 3) {
      setSelectedSub(physical);
    } else if (selected?.id === 4) {
      setSelectedSub(mental);
    } else if (selected?.id === 5) {
      setSelectedSub(social);
    } else if (selected?.id === 6) {
      setSelectedSub(societal);
    }
  };
  const { dispatch, start } = useContext(StepsContext);

  useEffect(() => {
    if (!start) navigate('/pageNotfound');
  }, [start]);

  const navigate = useNavigate();

  let neededWellbeingAreas = financialSelected.concat(
    professionalSelected,
    physicalSelected,
    socialSelected,
    mentalSelected,
    societalSelected
  );

  const finalData = {
    survey_id: state?.project_id,
    member_id: state?.member_id,
    person_type: personType,
    T1: stepone?.T1,
    T2: stepone?.T2,
    T3: stepone?.T3,
    E1: stepone?.E1,
    E2: stepone?.E2,
    E3: stepone?.E3,
    S1: stepone?.S1,
    S2: stepone?.S2,
    C1: stepone?.C1,
    C2: stepone?.C2,
    L1: stepone?.L1,
    L2: stepone?.L2,
    keyAreaTopTexts:
      selected === 'top'
        ? keyAreaTopTexts?.keyAreaTopTexts
        : {
            1: '',
            2: '',
            3: '',
          },
    keyAreaBottomTexts: keyAreaTopTexts?.keyAreaBottomTexts,
    selectedConstructsTop: selectedConstructsTop || [],
    selectedConstructsBottom: selectedConstructsBottom || [],
    physical_wellbeing: stepThree?.physical_wellbeing,
    professional_wellbeing: stepThree?.professional_wellbeing,
    social_wellbeing: stepThree?.social_wellbeing,
    financial_wellbeing: stepThree?.financial_wellbeing,
    societal_wellbeing: stepThree?.societal_wellbeing,
    mental_wellbeing: stepThree?.mental_wellbeing,
    physical_wellbeing_support: stepThree?.physical_wellbeing_support,
    social_wellbeing_support: stepThree?.social_wellbeing_support,
    societal_wellbeing_support: stepThree?.societal_wellbeing_support,
    mental_wellbeing_support: stepThree?.mental_wellbeing_support,
    professional_wellbeing_support: stepThree?.professional_wellbeing_support,
    financial_wellbeing_support: stepThree?.financial_wellbeing_support,
    selectedAbilities: selectedAbilities,
    selectedCostitems: selectedCostitems,
    feeling: feeling,
    neededWellbeingAreas: neededWellbeingAreas,
    resource_type: type,
  };

  const [loading, setLoading] = useState(false);
  const [pickle, setPickle] = useState(false);
  console.log('finalData', finalData);
  const handleClickNav = async () => {
    setLoading(true);
    await axios({
      method: 'post',
      url: `${process.env.REACT_APP_BASE_URL}/survey/saveSurveyData`,
      headers: { 'Content-Type': 'multipart/form-data' },
      data: finalData,
    })
      .then(function (response) {
        console.log(response);
        setLoading(false);
        setPickle(true);
        setTimeout(() => {
          setPickle(false);
          dispatch({
            type: 'STEP',
          });
          navigate('/submit', {
            state: {
              state: state,
              data: response.data,
              type: type,
              survey_id: survey_id,
              personType: personType,
            },
          });
        }, 1000);
        // window.location.reload();
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const [toastState, setToastState] = React.useState({
    open: false,
  });
  const handleCloseToast = () => {
    setToastState({
      open: !toastState.open,
    });
  };
  return (
    <div className="mainContainer">
      <Navbar
        special={
          REACT_APP_SURVEY_ID === survey_id ||
          REACT_APP_SURVEY_ID_ER === survey_id
        }
        minutesDisplay={minutesDisplay}
        secondsDisplay={secondsDisplay}
      />
      {pickle && <Pickles />}
      <div className="surveys-sub-container">
        <Steps er={REACT_APP_SURVEY_ID_ER === survey_id} step={33} active />
        <div className="inst-sub">
          {survey_id_manage === survey_id && (
            <FormControl sx={{ span: { color: 'green' } }}>
              <FormLabel
                id="demo-radio-buttons-group-label"
                className="!font-bold !text-xl"
              >
                Do you want free and paid resources or only free resources?
              </FormLabel>
              <RadioGroup
                aria-labelledby="demo-radio-buttons-group-label"
                value={type}
                row
                onChange={(e) => setType(e.target.value)}
                name="radio-buttons-group"
              >
                <FormControlLabel
                  value="free"
                  control={<Radio />}
                  label="Only free resources"
                />
                <FormControlLabel
                  value="both"
                  control={<Radio />}
                  label="Free & paid resources"
                />
              </RadioGroup>
            </FormControl>
          )}
          <div className="link-sub">
            Please tell us how we can help support your wellbeing.
          </div>
        </div>
        <div
          style={{
            fontSize: '18px',
            fontWeight: '500',
            color: '#233d8a',
            width: '60%',
          }}
        >
          Click on each area of wellbeing where you feel you need help or advice
          and select up to three services/solutions.
        </div>
        <div className="xs:!w-full md:!w-4/6 surveys-question-container surveys-question-container-areas surveys-question-container-two survey-slider-container">
          <div className="allAreas">
            {allAreas.map((area) => (
              <div
                key={area.id}
                className={selectedArea === area.id ? 'selectedareamm' : ''}
                onClick={() => handleClick(area)}
                style={{
                  color: selectedArea === area.id ? '#0c7c90' : '#000',
                }}
              >
                <div className="texts-s">
                  <div style={{ textAlign: 'center' }}>
                    {' '}
                    <FontAwesomeIcon
                      className="areasprofilecompany"
                      icon={listIcon[area.id - 1]}
                      color={`${selectedArea === area.id ? '#0c7c90' : '#000'}`}
                      size="2x"
                    />
                    <div>{area.name}</div>
                  </div>
                </div>
              </div>
            ))}
          </div>
          <div className="sub">
            {selectedSub?.map((sub, _) => (
              <Split
                key={_}
                handleCloseToast={handleCloseToast}
                selectedSub={selectedSub}
                sub={sub}
                selectedArea={selectedArea}
                setFinancialSelected={setFinancialSelected}
                setProfessionalSelected={setProfessionalSelected}
                setPhysicalSelected={setPhysicalSelected}
                setMentalSelected={setMentalSelected}
                setSocialSelected={setSocialSelected}
                setSocietalSelected={setSocietalSelected}
                financialSelected={financialSelected}
                professionalSelected={professionalSelected}
                physicalSelected={physicalSelected}
                socialSelected={socialSelected}
                mentalSelected={mentalSelected}
                societalSelected={societalSelected}
              />
            ))}
          </div>
        </div>
        <div className="submit-config xs:w-4/5">
          Kindly ensure that you have selected all required initiatives in all
          areas before clicking the 'Submit' button. You will not be able to
          modify this once you submit
        </div>
        <div className="btn-container">
          {/* <Link to={'/submit'}> */}
          <Button
            disabled={loading}
            // disabled={neededWellbeingAreas?.length < 1 || loading}
            onClick={handleClickNav}
            className="signupCVbtnSign"
            type="submit"
            variant="contained"
            style={{
              backgroundColor: loading ? '' : '#2691a3',
            }}
            sx={{
              fontSize: '16px',
              fontWeight: 500,
              padding: '8px 30px',
              textTransform: 'capitalize',
              backgroundColor: '#2691a3',
              '&.css-ke7xld-MuiButtonBase-root-MuiButton-root:hover': {
                backgroundColor: '#2691a3',
              },
            }}
          >
            Submit
          </Button>
          {/* </Link> */}
        </div>
        <Toast
          handleClose={handleCloseToast}
          state={toastState}
          error="Sorry, You cannot choose more than 3."
        />
        <Footer />
      </div>
    </div>
  );
}
